import { render, staticRenderFns } from "./systemTagList.vue?vue&type=template&id=5cae1d26&scoped=true&"
import script from "./systemTagList.vue?vue&type=script&lang=js&"
export * from "./systemTagList.vue?vue&type=script&lang=js&"
import style0 from "./systemTagList.vue?vue&type=style&index=0&id=5cae1d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae1d26",
  null
  
)

export default component.exports